import { Routes, RouterModule } from '@angular/router';
import { AuthguardService } from '../authguard.service';
import {PasswordComponent} from './password/password.component';

export const accountRoutes: Routes = [
    {
        path: 'account',
        component: PasswordComponent,
        canActivate: [AuthguardService], // comment out for testing during development
    }
];



// WEBPACK FOOTER //
// ./src/app/account/account.routes.ts